module.exports = __webpack_public_path__ + "static/media/bistecca-4.608ebce2.jpg";